import { Navigate, useParams } from "react-router-dom";
import { ArticleCarousel, ArticleMain } from "../../widget";
import { RoutesEnum } from "../../shared/constants/routes";

import { useGetPostQuery, useGetPostsQuery } from "../../entities/Blog/api/blogApi";

const CAROUSEL_LENGTH = 10;

export const ArticlePage = () => {
    const { id } = useParams<"id">();

    const { data: post, isLoading: isLoadingPost } = useGetPostQuery(id as string);

    const { data: posts, isLoading: isLoadingPosts } = useGetPostsQuery({ take: CAROUSEL_LENGTH });

    return id ? (
        <>
            {(post && !isLoadingPost) && <ArticleMain data={post} />}
            {(posts?.length && !isLoadingPosts) && <ArticleCarousel data={posts} />}
        </>
    ) : (
        <Navigate to={RoutesEnum.NotFound} />
    );
};
